// extracted by mini-css-extract-plugin
export default {"root":"mWDxhbI10NFqgtNgjwjj","placeHolderShimmer":"CplJDP3o2H8SUdVM0Yqc"};